import type { RoomDef } from '../../sim/types.ts';

/**
 * Room 1 — First Light (brief §6).
 *
 * Teaches the whole game in one screen: a 3-tile stone wall no jump can clear
 * (apex is 1.25 tiles, deliberately - exactly one block), and a floor-level path
 * that the wall blocks. The only way over is cast → jump → cast → jump: build your own
 * staircase. Everything after this room is composition.
 *
 * SCAFFOLD CONTENT. Layout is a working first pass, not final authored content
 * (brief §14, Sep 13-16). It exists so the solvability harness has something
 * real to prove itself against.
 *
 * RESOLVED 2026-09-04: the wall previously needed only two blocks, because the
 * old 2.25-tile jump apex cleared the top from a 2-block stack. The apex is now
 * 1.25 tiles - one cast block and no more - so all three staircase steps are
 * required and the recorded solution has no redundancy.
 */
export const firstLight: RoomDef = {
  id: '01-first-light',
  name: 'First Light',
  map: [
    '################',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..........#...#',
    '#..........#...#',
    '#..........#...#',
    '################',
    '################',
  ],
  spawn: { x: 3.5, y: 10 },
  portal: { tx: 14, ty: 9 },
  items: [
    // Buried in bare ground at (2, 9), behind the player's back at spawn. There
    // is no block over it: to uncover it you cast a block onto the tile and then
    // destroy that block, and the crumble reveals what was underneath.
    //
    // That is a different act from cutting open an authored Vine - it is the
    // player's own block doing the digging - and it is the reason cast and
    // destroy form a pair rather than two separate verbs.
    //
    // Optional by design: the canonical solution walks right and never touches
    // it, which is what a Sprite is meant to be (brief §6).
    { kind: 'sprite', tx: 2, ty: 9, hidden: true },
    { kind: 'lumen', tx: 5, ty: 9 },
    { kind: 'moonseed', tx: 12, ty: 9 },
  ],
  chimera: [],
};
